import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { getAppendOption, getUpsertOption } from 'app/registries/consts/copy-job-const';
import { UpdateMethod } from 'shell-models-lib';

const mongoSinkWriteBehaviors = [writeBehaviorOptionValues.insert, writeBehaviorOptionValues.upsert];

export const nativeMongoDbCollectionMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.mongoDb.datasetType,
    displayName: stringResources.MongoDbV2Collection_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.mongoDb.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'hierarchical',
    notSupportTypeConversion: true,
    notSupportPhysicalType: true,
    icon: {
        className: 'svg-i-100x100-MongoDBCollection'
    },
    isFirstClass: true,
    isTableNameRequired: true,
    tableNameDisplay: stringResources.TableNameDisplay_CollectionName,
    tableNamePlural: stringResources.Collections,
    category: ['NoSQL'],
    notSupportLookupActivity: true,
    supportCreatedAsV2: true,
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'batchSize',
                label: stringResources.ModelName_BatchSize,
                description: stringResources.MongoDB_BatchSize_Description
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            options: writeBehaviorAllOptions
                .filter((option) => mongoSinkWriteBehaviors.indexOf(option.value) >= 0)
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    versionConfig: __IS_FABRIC_DPE__ ? [
        {
            label: '1.1',
            value: '1.1',
            description: format(stringResources.Connector_Version_Description, 'https://go.microsoft.com/fwlink/?linkid=2301232'),
            escapeDescription: false
        },
        {
            label: '1.0',
            value: '1.0'
        }
    ]: undefined,
    defaultVersion: __IS_FABRIC_DPE__ ? '1.0' : undefined,
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getAppendOption(), getUpsertOption()],
            updateMethodProperties: ['writeBehavior'],
            defaultUpdateMethod: UpdateMethod.Append,
            noUpsertKeyColumn: true
        }
    }
};
